import React from 'react';
import Slider from "react-slick";

import Artist from './Artist';
import Spinner from '../Spinner/Spinner';

const ArtistList = ({ channels }) => {
	const artistsSliderSettings = {
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		rows: 3,
		dots: true,
		arrows: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	};

	return (
		<React.Fragment>
			{channels.length ? (
				<React.Fragment>
					{channels.length > 7 ? (
						<Slider {...artistsSliderSettings} className="artist_list">
							{channels.map(({ channel, artist, day, base_url, img, start_unix }, key) => {
								return (
									<div className="artist_list_item" key={start_unix + key}>
										<Artist
											path='/'
											img={base_url + img}
											channel={channel}
											artist={artist}
											day={day}
										/>
									</div>
								)
							})}
						</Slider>
					) : (
							<ul className="artist_list">
								{channels.map(({ channel, artist, day, base_url, img, start_unix }, key) => {
									return (
										<div className="artist_list_item" key={start_unix + key}>
											<Artist
												path='/'
												img={base_url + img}
												channel={channel}
												artist={artist}
												day={day}
											/>
										</div>
									)
								})}
							</ul>
						)}
				</React.Fragment>
			) : (
					<Spinner
						darkMod
					/>
				)}
		</React.Fragment>
	);
}
export default ArtistList;